import {API, Storage} from 'aws-amplify';
import {headers} from './helpers';

export const get = (
    path,
    init = {},
    name = process.env.REACT_APP_API_NAME,
    customHeaders= headers
) => {
  const data = {
    ...init,
    headers: customHeaders
  };
  return new Promise((resolve, reject) => {
    API.get(name, path, data)
        .then((res) => {
          resolve(res);
        })
        .catch((e) => {
          reject({type: 'err', ...e});
        });
  });
};

export const post = (
    path,
    json = {},
    name = process.env.REACT_APP_API_NAME
) => {
  const data = {
    headers,
    body: json
  };
  return new Promise((resolve, reject) => {
    API.post(name, path, data)
        .then((res) => resolve(res))
        .catch((e) => {
          reject({type: 'err', ...e});
        });
  });
};

export const put = (
    path,
    json = {},
    name = process.env.REACT_APP_API_NAME
) => {
  const data = {
    headers,
    body: json
  };
  return new Promise((resolve, reject) => {
    API.put(name, path, data)
        .then((res) => resolve(res))
        .catch((e) => {
          reject({type: 'err', ...e});
        });
  });
};

export const uploadS3 = (name) => {
  return new Promise((resolve, reject) => {
    Storage.get(name, {
      level: 'public',
      expires: 3600
    })
        .then((res) => resolve(res))
        .catch((e) => {
          reject({type: 'err', ...e});
        });
  });
};
